
import { ref, inject, shallowRef, reactive } from "vue";
import Header from "@/components/header/header.vue";
import OrderGoods from "@/components/goods/order-goods.vue";
import { Toast, Dialog } from "vant";
import router from "@/router";
import payNowPopup from '@/components/pay-now-popup/payNowPopup.vue'
import { useRoute } from "vue-router";
import listEmpty from '@/components/list_empty.vue';
import downloadApp from '@/components/download/downloadApp.vue'
import { getShowAfter } from '@/hooks/afterSale'
export default {
  components: {
    Header,
    OrderGoods,
    payNowPopup,
    listEmpty,
    downloadApp
  },
  props: {},
  setup(props: object) {
    const route = useRoute();
    const loading = ref(false);
    const $http: any = inject("$http");
    const finished = ref(false);
    const isShowDownload = ref(false);
    let u = navigator.userAgent;
    let isAndroid = ref(u.indexOf('Android') > -1 || u.indexOf('Adr') > -1)   //判断是否是 android终端
    let isLiteApp = Boolean(window.androidWebObject)
    // let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    let tab_sld_name = ref(route.query.name?route.query.name:"state_new");
    const tab_list = shallowRef([
      { name: "Unpaid", value: "state_new" },
      { name: "To be Shipped", value: "state_paid" },
      { name: "Shipped", value: "state_trasit" },
      { name: "Completed", value: "state_complete" },
      { name: "Cancelled", value: "state_cancel" },
    ]);
    let list: any = shallowRef([]);
    let isShowPayPop = ref(false);
    const product = reactive({
      size: 10,
      page: 1,
      total: 500,
    });
     const m_pesa_show = ref(false);
    const m_pesa_phone = ref('');
    const mpesa_loading = ref(false);
    const m_pesa_error_msg_show = ref(false);
    const isAfter = ref(false); // 新售后开关是否开启
    
    const get_orders_list = async () => {
      loading.value = true
      let ret = await $http.orders({
        size: product.size,
        page: product.page,
        state: tab_sld_name.value,
      });
      
      if (ret.code === 200 && ret.data.length > 0) {
        if(ret.meta.current_page == 1) {
          list.value = []
        }
        product.page += 1
        list.value = list.value.concat(ret.data);
        if (product.page > ret.meta.last_page  ) {
          finished.value = true;
        } 
      }else {         
              finished.value = true
          }  
      loading.value = false
    };
    const getListFn = (name: any) => {
      list.value = []
      router.push({
        path:"/order",
        query:{
          name:name
        }}
      )
      product.page = 1
      tab_sld_name.value = name;
      finished.value = false
      get_orders_list();
    };
    const onLoad = async () => {
      get_orders_list();
    };
    // 取消订单
    const click_cancel_fn = (datas: any) => {
      Dialog.confirm({
        //是否取消这些商品
        message: "Are you sure cancel?",
        confirmButtonText: "YES",
        cancelButtonText: "NO",
      })
        .then(() => {
          review_message_post_fn(datas, "buyer_cancel");
        })
        .catch(() => {
          // Toast({
          //   message: "Undelete",
          // });
        });
    };
    /**
     * 订单操作
     */
    const review_message_post_fn = async (datas: any, action: any) => {
      loading.value = true;
      let ret = await $http.order_change_state({
        action: action,
        sn: datas.sn,
        pay_sn: datas.pay_sn,
      });
      loading.value = false;
      if (ret.code === 200) {
        product.page = 1
        finished.value = false
        Toast({
          type: "success",
          message: "successfully!",
        });
          list.value = []
        get_orders_list();
      }
    };
     
    let payInfo = reactive({
      receiver: {
        phone: "",
      },
      pay_sn: "",
      amount_goods: "",
      amount_pay:'',
    });
    const pay_now_click_fn = (item: any) => {
      payInfo.receiver = item.receiver;
      m_pesa_phone.value = payInfo.receiver.phone 
      payInfo.pay_sn = item.pay_sn;
      payInfo.amount_goods = item.amount_goods;
      payInfo.amount_pay = item.amount_pay
      isShowPayPop.value = true;
    };
    // 删除
    const click_delete_fn = (datas: any) => {
      Dialog.confirm({
        //是否删除这些商品
        message: "Are you sure delete?",
        confirmButtonText: "YES",
        cancelButtonText: "NO",
      })
        .then(() => {
         review_message_post_fn(datas, "buyer_delete");
        })
        .catch(() => {
          // Toast({
          //   message: "Undelete",
          // });
        });
    };
   const closePopupFn = (e:boolean) => {
     isShowPayPop.value = e
   }
   const goOrderDetailFn = (item:any) => {
     let id = item.sn + ',' + item.pay_sn
     router.push({
       path:'/orderDetails',
       query:{
         id:id,
         name:tab_sld_name.value
       }
     })
   }
    // 去店铺
    const goShopFn = (storeItem:any) => {
      router.push(
         {
          name:'shop',
          params:{id:storeItem.store_id}
         }
      )
    }
    /**
       * m-pesa 支付
       */
      const m_pesa_submit_fn = () => {
        mpesa_loading.value = true;
        let phone_val = m_pesa_phone.value || ''
        phone_val = String(phone_val).replace(/(^254*)/g, '')
        if(m_pesa_phone.value === '' || !new RegExp(/^[0]{1}[1-9]{1}[0-9]{8}$|^[1-9]{1}[0-9]{8}$/).test(phone_val)){
            m_pesa_error_msg_show.value = true;
            mpesa_loading.value = false;
            return;
        }
        m_pesa_show.value = false
        m_pesa_error_msg_show.value = false;
        router.push(
          `/mpesa?phone=${phone_val}&pay_sn=${payInfo.pay_sn}`
        );
      };
      const m_pesa_showFn = (e:boolean) => { 
        m_pesa_show.value = e
      }
      const click_aftersale_fn = (item:any) => {
        if(isAfter.value){
          router.push(`/afterSale?name=state_apply&order_sn=${item.sn}`)
        }else{
          isShowDownload.value = true
        }
      }
       const  onClickHide = () => {
        isShowDownload.value = false
        }
        const download_fn = () => {
           window.location.href = 'https://play.google.com/store/apps/details?id=net.kilimall.shop'
        }
    getShowAfter().then((res:any)=>{
      if(res.code === 200){
        //  new_aftersale_isuse 为1表示售后开关开启,反之则是关闭的
        isAfter.value = !!res.data.new_aftersale_isuse
      }
        
    })
    return {
      tab_sld_name,
      loading,
      onLoad,
      tab_list,
      getListFn,
      finished,
      list,
      click_cancel_fn,
      pay_now_click_fn,
      isShowPayPop,
      payInfo,
      click_delete_fn,
      closePopupFn,
      goOrderDetailFn,
      goShopFn,
      m_pesa_show,
      m_pesa_phone,
      mpesa_loading,
      m_pesa_error_msg_show,
      m_pesa_showFn,
      m_pesa_submit_fn,
      click_aftersale_fn,
      isShowDownload,
      onClickHide,
      download_fn,
      isAndroid,
      isAfter,
      isLiteApp
    };
  },
};
